export default __webpack_public_path__ + "static/media/TF2-2.d8d58bfa.jpg";